import React, { useState } from 'react';
import { FormattedMessage } from '../../../util/reactIntl';

import BuildProfileIcon from "./icons/BuildProfileIcon";
import ListCoursesIcon from "./icons/ListCoursesIcon";
import TeachAndEarnIcon from "./icons/TeachAndEarnIcon";
import EarnEvenMoreeIcon from "./icons/EarnEvenMoreeIcon";
import ShareMaterialsIcon from "./icons/ShareMaterialsIcon";
import LearnMoreIcon from "./icons/LearnMoreIcon";

import { ExternalLink, Modal, ModalInviteFriend, NamedLink } from "../../../components";
import classNames from "classnames";

import css from './SectionTeachingWithAllCourse.module.css';
import { getBullets } from '../../../util/contentful';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

const SectionTeachingWithAllCourse = props => {

  const { onManageDisableScrolling, currentUser, currentState, currentSubject, content } = props;

  const [isInviteFriendOpen, setIsInviteFriendOpen] = useState(false)

  const handleInviteFriendClose = () => setIsInviteFriendOpen(false);

  const items = content && getBullets(content, 'teachingBullet');

  return (
    <div className={css.root}>
      {content ? (
        <>
          <div className={css.rootTitleHolder}>
            <h2 className={css.rootTitle}>
              {content?.teachingTitle}
            </h2>
          </div>

          <p className={css.rootDescription}>
            {content?.teachingDescription}
          </p>

          <div className={css.teachersInfo}>
            {Array.from(Array(Object.keys(items).length / 3).keys()).map(i => (
              <div className={classNames(css.teachersInfoItem, css.teachersInfoItem1)}>
                <div className={css.imageHolder}>
                  <img src={`https:${items[`teachingBullet${i + 1}Icon`].fields?.file?.url}`} className={css.image}  alt={items[`teachingBullet${i + 1}Title`]}/>
                </div>
                <div className={css.teachersInfoItemContent}>
                  <h3 className={css.teachersInfoItemTitle}>
                    {items[`teachingBullet${i + 1}Title`]}
                  </h3>
                  <p className={css.teachersInfoItemDescription}>
                    {documentToReactComponents(items[`teachingBullet${i + 1}Description`])}
                  </p>
                </div>
              </div>
            ))}

            <Modal
              id="TopbarInviteFriend"
              isOpen={isInviteFriendOpen}
              onClose={handleInviteFriendClose}
              usePortal
              onManageDisableScrolling={onManageDisableScrolling}
              closeButtonMessage={" "}
            >
              <ModalInviteFriend
                currentUser={currentUser}
                onManageDisableScrolling={onManageDisableScrolling}
              />
            </Modal>
          </div>
        </>
      ) : (
        <>
          <div className={css.rootTitleHolder}>
            <h2 className={css.rootTitle}>
              {currentState && !currentSubject ?
                <FormattedMessage id='SectionTeachingWithAllCourse.stateTitle' values={{ state: currentState?.label }} /> :
                currentState && currentSubject ?
                  <FormattedMessage id='SectionTeachingWithAllCourse.subjectTitle' values={{ state: currentState?.label, subject: currentSubject?.parent }} /> :
                <FormattedMessage id="SectionTeachingWithAllCourse.title" />
              }
            </h2>
          </div>

          <p className={css.rootDescription}>
            <FormattedMessage id="SectionTeachingWithAllCourse.description" />
          </p>

          <div className={css.teachersInfo}>
            <div className={classNames(css.teachersInfoItem, css.teachersInfoItem1)}>
              <BuildProfileIcon />
              <div className={css.teachersInfoItemContent}>
                <h3 className={css.teachersInfoItemTitle}>
                  <FormattedMessage id="SectionTeachingWithAllCourse.itemTitle1" />
                </h3>
                <p className={css.teachersInfoItemDescription}>
                  <FormattedMessage
                    id="SectionTeachingWithAllCourse.itemDescription1"
                    values={{
                      link: (
                        <NamedLink
                          className={css.link}
                          name="SignupTeacherPage"
                          to={{ userRole: 'teacher' }}
                        >
                          <FormattedMessage id="SectionTeachingWithAllCourse.freeProfile" />
                        </NamedLink>
                      )
                    }}
                  />
                </p>
              </div>
            </div>

            <div className={classNames(css.teachersInfoItem, css.teachersInfoItem2)}>
              <ListCoursesIcon />
              <div className={css.teachersInfoItemContent}>
                <h3 className={css.teachersInfoItemTitle}>
                  <FormattedMessage id="SectionTeachingWithAllCourse.itemTitle2" />
                </h3>
                <p className={css.teachersInfoItemDescription}>
                  <FormattedMessage id="SectionTeachingWithAllCourse.itemDescription2" />
                </p>
              </div>
            </div>

            <div className={classNames(css.teachersInfoItem, css.teachersInfoItem3)}>
              <LearnMoreIcon />
              <div className={css.teachersInfoItemContent}>
                <h3 className={css.teachersInfoItemTitle}>
                  <FormattedMessage id="SectionTeachingWithAllCourse.itemTitle3" />
                </h3>
                <p className={css.teachersInfoItemDescription}>
                  <FormattedMessage id="SectionTeachingWithAllCourse.itemDescription3" />
                </p>
              </div>
            </div>

            <div className={classNames(css.teachersInfoItem, css.teachersInfoItem4)}>
              <TeachAndEarnIcon />
              <div className={css.teachersInfoItemContent}>
                <h3 className={css.teachersInfoItemTitle}>
                  <FormattedMessage id="SectionTeachingWithAllCourse.itemTitle4" />
                </h3>
                <p className={css.teachersInfoItemDescription}>
                  <FormattedMessage id="SectionTeachingWithAllCourse.itemDescription4" />
                </p>
              </div>
            </div>

            <div className={classNames(css.teachersInfoItem, css.teachersInfoItem5)}>
              <EarnEvenMoreeIcon />
              <div className={css.teachersInfoItemContent}>
                <h3 className={css.teachersInfoItemTitle}>
                  <FormattedMessage id="SectionTeachingWithAllCourse.itemTitle5" />
                </h3>
                <p className={css.teachersInfoItemDescription}>
                  <FormattedMessage
                    id="SectionTeachingWithAllCourse.itemDescription5"
                    values={{
                      referralLink: (
                        <NamedLink
                          name="ReferralPage"
                          className={css.link}
                        >
                          <FormattedMessage id="SectionTeachingWithAllCourse.seeDetails" />
                        </NamedLink>
                      )
                    }}
                  />
                </p>
              </div>
            </div>

            <div className={classNames(css.teachersInfoItem, css.teachersInfoItem6)}>
              <ShareMaterialsIcon />
              <div className={css.teachersInfoItemContent}>
                <h3 className={css.teachersInfoItemTitle}>
                  <FormattedMessage id="SectionTeachingWithAllCourse.itemTitle6" />
                </h3>
                <p className={css.teachersInfoItemDescription}>
                  <FormattedMessage
                    id="SectionTeachingWithAllCourse.itemDescription6"
                    values={{
                      aiLink:(
                        <ExternalLink
                          href="https://www.bookbaker.com/"
                          className={css.link}
                        >
                          <FormattedMessage id="SectionTeachingWithAllCourse.aiLearning" />
                        </ExternalLink>
                      ),
                      freeLearningLink: (
                        <ExternalLink
                          href="https://home.allcourse.com/"
                          className={css.link}
                        >
                          <FormattedMessage id="SectionTeachingWithAllCourse.freeLearning" />
                        </ExternalLink>
                      )
                    }}
                  />
                </p>
              </div>
            </div>

            <Modal
              id="TopbarInviteFriend"
              isOpen={isInviteFriendOpen}
              onClose={handleInviteFriendClose}
              usePortal
              onManageDisableScrolling={onManageDisableScrolling}
              closeButtonMessage={" "}
            >
              <ModalInviteFriend
                currentUser={currentUser}
                onManageDisableScrolling={onManageDisableScrolling}
              />
            </Modal>
          </div>
        </>
      )}
    </div>
  );
};

export default SectionTeachingWithAllCourse;
